import React from 'react';
import { MapPin, Phone, Clock, MessageCircle, Navigation } from 'lucide-react';

const Location = () => {
  return (
    <section id="ubicacion" className="py-16 md:py-24 bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Encontranos en <span className="text-[#7cb342]">Rosario</span>
          </h2>
          <p className="font-body text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
            Ubicados en Boulevard Rondeau, en el corazón del barrio Alberdi.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Contact Info */}
          <div className="space-y-6">
            {/* Address */}
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-[#252525]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#7cb342]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} className="text-[#7cb342]" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-white mb-1">Dirección</h3>
                  <p className="font-body text-gray-400">Blvd. Rondeau 1602</p>
                  <p className="font-body text-gray-400">S2000 Rosario, Santa Fe</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-[#252525]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#7cb342]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone size={24} className="text-[#7cb342]" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-white mb-1">Teléfono</h3>
                  <a 
                    href="tel:03416802275" 
                    className="font-body text-gray-400 hover:text-[#7cb342] transition-colors"
                  >
                    0341 680-2275
                  </a>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-[#252525]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#7cb342]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock size={24} className="text-[#7cb342]" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-white mb-1">Horarios</h3>
                  <p className="font-body text-gray-400">Consultá horarios actualizados</p>
                  <p className="font-body text-gray-400">en Google Maps o WhatsApp</p>
                </div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="https://wa.me/5493416802275"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-heading uppercase tracking-wider font-semibold text-sm"
              >
                <MessageCircle size={18} />
                WhatsApp
              </a>
              <a
                href="https://www.google.com/maps/dir//Blvd.+Rondeau+1602,+S2000+Rosario,+Santa+Fe,+Argentina"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-heading uppercase tracking-wider font-semibold text-sm"
              >
                <Navigation size={18} />
                Cómo Llegar
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="bg-[#1a1a1a] rounded-xl overflow-hidden border border-[#252525] h-[300px] md:h-[400px] lg:h-full lg:min-h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.5693981574!2d-60.6831!3d-32.9441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab3d8f8e1b1f%3A0x1234567890abcdef!2sBlvd.%20Rondeau%201602%2C%20S2000%20Rosario%2C%20Santa%20Fe%2C%20Argentina!5e0!3m2!1ses!2sar!4v1705855200000!5m2!1ses!2sar"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '300px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Cosme Alberdi - Blvd. Rondeau 1602, Rosario"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
